module.exports = __webpack_public_path__ + "media/packs/images/flags/BJ-ad8e4891770a8269ff81cf21e019c1f9.svg";